import React, { cloneElement, ReactElement } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import {
    ParticipantInstrumentStatus,
    ProgramParticipantScoringStatus,
} from "../../../../../../services/types/scoringStatusTypes";
import { ParticipantInstrumentStatus as NewParticipantInstrumentStatus } from "../../../../../../services/types/enterpriseParticipantApiTypes";
import { eGrayCellColors } from "./assessmentStatusColors";
import { ParticipantAssessmentStatus } from "../../../../../../services/types/enterpriseParticipantApiTypes";

export interface RaterStatusCellProps {
    participant?: ProgramParticipantScoringStatus | ParticipantAssessmentStatus;
    assessment?: ParticipantInstrumentStatus;
    assessmentNew?: NewParticipantInstrumentStatus;
    instrumentId: number;
    raterId: number;
    isWide: boolean;
}

const RaterStatusCell: React.FC<RaterStatusCellProps> = (props) => {
    let invited: number = 0;
    let completed: number = 0;
    let minRequired: number = 0;
    let recievedLate: number = 0;
    let icon: ReactElement = <CheckCircleIcon />;
    let color: eGrayCellColors = eGrayCellColors.Green;

    if (props.assessment) {
        if (props.assessment.selfAssessmentStatusTypeId !== 5 && props.assessment.forms != null) {
            const raterDetails = props.assessment.forms.find(
                (f) => f.raterTypeId === props.raterId
            );
            if (raterDetails != null) {
                minRequired = raterDetails.minimumRequired;
                invited = raterDetails.surveysSent;
                completed = raterDetails.receivedCount;
                recievedLate = raterDetails.receivedLateCount;
            }
        }
    } else if (props.assessmentNew) {
        if (
            props.assessmentNew.selfAssessmentStatusTypeId !== 5 &&
            props.assessmentNew.raters != null
        ) {
            const raterDetails = props.assessmentNew.raters.find(
                (f) => f.raterTypeId === props.raterId
            );
            if (raterDetails != null) {
                minRequired = raterDetails.minimumRequired;
                invited = raterDetails.surveysSent;
                completed = raterDetails.receivedCount;
                recievedLate = raterDetails.receivedLateCount;
            }
        }
    } else if (props.participant !== undefined) {
        if ("esiKey" in props.participant) {
            const paxInstrument = props.participant.instruments.find(
                (i) => i.instrumentId === props.instrumentId
            );
            if (paxInstrument != null) {
                const raterDetails = paxInstrument.raters.find(
                    (f) => f.raterTypeId === props.raterId
                );
                // make sure it's not cancelled, if it is we leave all the counts at 0 so use the do not disturb icon/gray color
                if (paxInstrument.selfAssessmentStatusTypeId !== 5 && raterDetails != null) {
                    minRequired = raterDetails.minimumRequired;
                    invited = raterDetails.surveysSent;
                    completed = raterDetails.receivedCount;
                    recievedLate = raterDetails.receivedLateCount;
                }
            }
        } else {
            const paxInstrument = props.participant.instruments.find(
                (i) => i.instrumentId === props.instrumentId
            );
            if (paxInstrument != null) {
                const raterDetails = paxInstrument.forms.find(
                    (f) => f.raterTypeId === props.raterId
                );
                // make sure it's not cancelled, if it is we leave all the counts at 0 so use the do not disturb icon/gray color
                if (paxInstrument.selfAssessmentStatusTypeId !== 5 && raterDetails != null) {
                    minRequired = raterDetails.minimumRequired;
                    invited = raterDetails.surveysSent;
                    completed = raterDetails.receivedCount;
                    recievedLate = raterDetails.receivedLateCount;
                }
            }
        }
    }
    let highlightCompleted: boolean = completed < minRequired;
    let highlightInvited: boolean = invited < minRequired;

    if (completed < minRequired) {
        icon = <WarningIcon />;
        color = eGrayCellColors.Orange;
    } else if (invited === 0) {
        icon = <DoNotDisturbIcon />;
        color = eGrayCellColors.Grey;
    } else if (completed === 0) {
        icon = <PanoramaFishEyeIcon />;
        color = eGrayCellColors.Blue;
    } else {
        icon = <CheckCircleIcon />;
        if (recievedLate > 0) {
            color = eGrayCellColors.Red;
        } else if (completed === invited) {
            color = eGrayCellColors.Green;
        } else {
            color = eGrayCellColors.Blue;
        }
    }

    //var iconMarginLeft = props.isWide ? 18 : 2;
    var iconMarginLeft = 2;
    icon = cloneElement(icon, {
        fontSize: "small",
        style: { color: color, marginLeft: iconMarginLeft },
    });

    return (
        <>
            {icon}
            <span
                style={{
                    paddingLeft: 2,
                    color: highlightCompleted ? eGrayCellColors.Orange : "inherit",
                }}
            >
                {completed}
            </span>
            <span> &nbsp;of&nbsp; </span>
            <span style={{ color: highlightInvited ? eGrayCellColors.Orange : "inherit" }}>
                {invited}
            </span>
            {recievedLate > 0 ? (
                <span>
                    &nbsp;(<span style={{ color: eGrayCellColors.Red }}>{recievedLate}</span>)
                </span>
            ) : null}
        </>
    );
};

export default RaterStatusCell;
